export default __webpack_public_path__ + "static/media/TRUCK4.7f51ccda.jpg";